type SvgProps = {
    className: string,
};

const ArrowDown = (props: SvgProps): JSX.Element => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.025 3a1 1 0 011 1v15a1 1 0 11-2 0V4a1 1 0 011-1z"
            stroke="none"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.294 12.242a1 1 0 011.415.003l5.316 5.338 5.315-5.338a1 1 0 011.418 1.41l-6.024 6.05a1 1 0 01-1.418 0l-6.025-6.05a1 1 0 01.003-1.413z"
            stroke="none"
        />
    </svg>
);

export default ArrowDown;
